"use client";
import React from "react";
import { RingLoader } from "react-spinners";

interface LoadingSpinnerProps {
  color?: string;
  size?: number;
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  color = "#fff", 
  size = 30, 
  className = "" 
}) => {
  try {
    return (
      <div className={`inline-flex items-center justify-center ${className}`}>
        <RingLoader color={color} size={size} />
      </div>
    );
  } catch (error) {
    console.error("LoadingSpinner error:", error);
    // 降级到简单的 CSS 加载动画
    return (
      <div 
        className={`inline-block h-[${size}px] w-[${size}px] animate-spin rounded-full border-2 border-solid border-current border-r-transparent ${className}`}
        style={{ 
          borderColor: color,
          borderRightColor: 'transparent',
          width: size,
          height: size
        }}
      />
    );
  }
};

export default LoadingSpinner;